// import { ActionType } from '../actionType';
import { beneficiariesForm, PEPForm } from './beneficiariesForm';
import { BeneficiariesActions, PepActions, BeneficiariesActionTypes } from './action';

export const reducer = (state: beneficiariesForm[], action: BeneficiariesActions): beneficiariesForm[] => {
  switch (action.type) {
    case BeneficiariesActionTypes.ADD: {
      return [...state, action.payload];
    }
    case BeneficiariesActionTypes.REMOVE: {
      return state.filter((a) => a.id !== action.payload.id);
    }
    case BeneficiariesActionTypes.SET: {
      return [...action.payload];
    }
    case BeneficiariesActionTypes.UPDATEITEM: {
      if (!action.payload.id) return state; // 无效的 payload 不更新
      const index = state.findIndex((a) => a.id === action.payload.id);
      if (index === -1) return state; // 找不到对应的条目时，直接返回原始 state

      // 使用深拷贝保持其他字段的完整性
      const newState = [...state];
      const { id, beneficiaryAction, ...rest } = action.payload;

      // 合并时避免丢失其他上下文值
      newState[index] = {
        ...newState[index],
        ...rest, // 合并新属性
        beneficiaryAction:
          newState[index].beneficiaryAction === 'add' ? newState[index].beneficiaryAction : beneficiaryAction,
      };
      console.log(newState);
      return newState; // 返回更新后的新 state
    }
    default:
      return state;
  }
};

export const PepReducer = (state: PEPForm, action: PepActions): PEPForm => {
  switch (action.type) {
    case 'SAVE_PEP':
      return {
        ...state,
        ...action.payload,
      };
    case 'RESET_PEP':
      return {
        isDeclaration: 'No',
        pepName: '',
        pepPosition: '',
        relevantPartyName: '',
        pepRelationship: '',
      };
    default:
      return state;
  }
};
